const setting = {
  layout: 'topmenu',
  contentWidth: 'fixed',
  hideLayoutInIframe: true,
  // your iconfont Symbol Scrip Url
  // eg：//at.alicdn.com/t/font_1039637_btcrd5co4w.js
  // 注意：如果需要图标多色，Iconfont图标项目里要进行批量去色处理
  iconfontUrl: '',
};
export default setting;
